import { Title as titleKey } from './pre'
import { planTypes } from '@/common/constants';
import { getPlanLogo } from '@/common/plan-logo-map';

export default {
  name: 'AdditionalHost',
  data() {
    return {
      description: this.$t('billing.events.addon.hub_hosts_desc'),
      desc: this.$t('billing.events.addon.hub_hosts_attendees_desc_new'),
      title: this.$t(titleKey),
      logo: getPlanLogo(planTypes.ADDITIONAL_HOST),
      planType: planTypes.ADDITIONAL_HOST
    };
  },
};
